import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import styles from "./InfiniteCarousel.module.css";

import img2 from "../assets/img/empresasClientes/image2.png";
import img3 from "../assets/img/empresasClientes/image3.png";
import img4 from "../assets/img/empresasClientes/image4.png";
import img5 from "../assets/img/empresasClientes/image5.png";
import img6 from "../assets/img/empresasClientes/image6.png";
import img7 from "../assets/img/empresasClientes/image7.png";
import img8 from "../assets/img/empresasClientes/image8.png";
import img11 from "../assets/img/empresasClientes/image11.png";
import img12 from "../assets/img/empresasClientes/image12.png";
import img14 from "../assets/img/empresasClientes/image14.png";
import img15 from "../assets/img/empresasClientes/image15.png";
import img16 from "../assets/img/empresasClientes/image16.png";
import img18 from "../assets/img/empresasClientes/image18.png";
import img19 from "../assets/img/empresasClientes/image19.png";
import img20 from "../assets/img/empresasClientes/image20.png";
import img21 from "../assets/img/empresasClientes/image21.png";
import img22 from "../assets/img/empresasClientes/image22.png";
import img23 from "../assets/img/empresasClientes/image23.png";
import img27 from "../assets/img/empresasClientes/image27.jpg";
import img28 from "../assets/img/empresasClientes/image28.png";
import img29 from "../assets/img/empresasClientes/image29.png";
import img30 from "../assets/img/empresasClientes/image30.jpg";
import img31 from "../assets/img/empresasClientes/image31.jpg";

const LOGOS = [
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img11,
  img12,
  img14,
  img15,
  img16,
  img18,
  img19,
  img20,
  img21,
  img22,
  img23,
  img27,
  img28,
  img29,
  img30,
  img31,
];

// Split the set in half so each row scrolls a different, still-varied
// sequence — reads less like one row duplicated twice.
const half = Math.ceil(LOGOS.length / 2);
const rowA = [...LOGOS.slice(0, half), ...LOGOS.slice(0, half)];
const rowB = [...LOGOS.slice(half), ...LOGOS.slice(half)];

interface LogoRowProps {
  logos: string[];
  reverse?: boolean;
  onSelect: (src: string) => void;
  ariaHidden?: boolean;
}

const LogoRow = ({ logos, reverse, onSelect, ariaHidden }: LogoRowProps) => (
  <div
    className={reverse ? styles.rowReverse : styles.row}
    aria-hidden={ariaHidden}
  >
    {logos.map((logoSrc, index) => (
      <button
        key={index}
        type="button"
        className={styles.logoCard}
        onClick={() => onSelect(logoSrc)}
        tabIndex={ariaHidden ? -1 : 0}
      >
        <img src={logoSrc} alt="" className={styles.logoImg} loading="lazy" />
      </button>
    ))}
  </div>
);

const InfiniteCarousel = () => {
  const [modalShow, setModalShow] = useState(false);
  const [selectedLogo, setSelectedLogo] = useState<string | null>(null);

  const handleLogoClick = (logoSrc: string) => {
    setSelectedLogo(logoSrc);
    setModalShow(true);
  };

  return (
    <div className={styles.section}>
      <div className={styles.header} data-aos="fade-up">
        <span className={styles.eyebrow}>Confiança de mercado</span>
        <h1 className={styles.title}>Nossos Clientes</h1>
      </div>

      <div className={styles.track}>
        <LogoRow logos={rowA} onSelect={handleLogoClick} />
        <LogoRow logos={rowB} reverse onSelect={handleLogoClick} />
      </div>

      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        centered
        size="lg"
        dialogClassName={styles.modalDialog}
        contentClassName={styles.modalContent}
      >
        <Modal.Header closeButton className={styles.modalHeader}>
          <Modal.Title className={styles.modalTitle}>
            Informações do Cliente
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.modalBody}>
          <div className={styles.modalLogoFrame}>
            <img
              src={selectedLogo || ""}
              alt="Logo do cliente selecionado"
              className={styles.modalLogo}
            />
          </div>
          <p className={styles.modalText}>Detalhes do cliente aqui...</p>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default InfiniteCarousel;